let LANGUAGE = require("../languages/english").default;
const LANGUAGE_DEFAULT = require("../languages/english").default;
export let CURRENT_LANGUAGE = "ENGLISH";

export let humanReadableLanguage = (language) => {
  return (
    {
      ENGLISH: "English",
      TE_REO: "Te Reo Māori",
      HINDI: "Hindi",
    }[language] || "English"
  );
};

export let languageExample = (language) => {
  return {
    ENGLISH:
      "With love and kindness, and working together, we can make this world a better place.",
    TE_REO:
      "Ma te aroha me te atawhai, me te mahi tahi, ka taea e tatou te whakapai ake i tenei ao.",
    HINDI:
      "प्यार और दया से और साथ मिलकर काम करके हम इस दुनिया को एक बेहतर जगह बना सकते हैं।",
  }[language];
};

export const localize = (key) => {
  return LANGUAGE[key] || LANGUAGE_DEFAULT[key] || key;
};

export const updateLanguage = (language) => {
  switch (language) {
    case "ENGLISH":
      LANGUAGE = require("../languages/english").default;
      break;
    case "TE_REO":
      LANGUAGE = require("../languages/te-reo").default;
      break;
    case "HINDI":
      LANGUAGE = require("../languages/hindi").default;
      break;
    default:
      LANGUAGE = require("../languages/english").default;
  }

  CURRENT_LANGUAGE = language;
};
